var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoActivityFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 107,
    viewBox: "0 0 113 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.083 53.0923C111.083 82.4143 87.3124 106.185 57.9904 106.185C28.6684 106.185 4.89795 82.4143 4.89795 53.0923C4.89795 23.7704 28.6684 0 57.9904 0C87.3124 0 111.083 23.7704 111.083 53.0923Z",
    fill: "#EFF8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.729 80.1653C66.729 85.8894 62.0884 90.5297 56.3642 90.5297C50.64 90.5297 46 85.8894 46 80.1653C46 74.4408 50.64 69.8008 56.3642 69.8008C62.0884 69.8008 66.729 74.4408 66.729 80.1653Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.729 80.1653C66.729 85.8894 62.0884 90.5297 56.3642 90.5297C50.64 90.5297 46 85.8894 46 80.1653C46 74.4408 50.64 69.8008 56.3642 69.8008C62.0884 69.8008 66.729 74.4408 66.729 80.1653Z",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9168 18.0568C65.861 22.8461 61.9335 26.6836 57.1442 26.6278C52.3549 26.5721 48.5177 22.6443 48.5734 17.855C48.6291 13.0657 52.5567 9.22877 57.346 9.28451C62.1353 9.34024 65.9725 13.2675 65.9168 18.0568Z",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3558 66.0176C81.0121 57.2584 81.3543 44.0628 81.3928 43.3064C81.4179 42.8128 81.3957 40.9365 81.3957 40.9365C80.8245 28.689 71.0208 18.5474 58.5676 17.7943L58.5677 17.7931C58.5607 17.7927 58.5536 17.793 58.5466 17.7926C58.5393 17.7922 58.532 17.7912 58.5249 17.7909L58.5249 17.7921C46.0596 17.2774 35.2772 26.3716 33.4662 38.498C33.4662 38.498 33.2533 40.3623 33.2282 40.8559C33.1897 41.6123 32.1913 54.7745 29.9655 63.3521C26.2772 77.5666 19.8752 78.5116 19.8752 78.5116L55.3655 80.3172L90.8551 82.1229C90.8551 82.1229 90.7537 82.0549 90.5722 81.9142C89.2773 80.908 83.9165 76.1918 82.3558 66.0176Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1401 65.005C81.4542 56.3052 81.2791 43.1063 81.2879 42.3489C81.2936 41.8548 81.1979 39.9808 81.1979 39.9808C80.1472 27.765 69.9536 18.0154 57.4805 17.7509L57.4805 17.7497C57.4735 17.7496 57.4664 17.7501 57.4594 17.7501C57.452 17.75 57.4447 17.7493 57.4377 17.7492L57.4376 17.7504C44.9618 17.7246 34.544 27.2344 33.2096 39.4223C33.2096 39.4223 33.07 41.2936 33.0643 41.7878C33.0554 42.5451 32.5736 55.7363 30.6856 64.3946C27.5572 78.7427 21.1972 79.9378 21.1972 79.9378L56.7309 80.3513L92.264 80.7648C92.264 80.7648 92.1601 80.7009 91.9731 80.5674C90.6398 79.6127 85.0983 75.1102 83.1401 65.005Z",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5018 66.7017L30.2844 66.0824C27.0455 78.8306 21.1969 79.9383 21.1969 79.9383L56.7306 80.3518L92.2641 80.7653C92.2641 80.7653 92.1918 80.7118 92.06 80.6056C90.9251 79.6914 85.3766 74.8733 83.5018 66.7017Z",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1642 54.4941C50.1642 54.4941 53.9715 55.9471 58.2021 55.9471C62.4324 55.9471 66.6629 54.4941 66.6629 54.4941",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.208 45.6934C42.208 45.6934 43.9801 46.5875 45.949 46.5875C47.9181 46.5875 49.887 45.6934 49.887 45.6934",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5466 45.6934C64.5466 45.6934 66.3184 46.5875 68.2876 46.5875C70.2564 46.5875 72.2256 45.6934 72.2256 45.6934",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.041 5.86719C78.8632 5.86719 72.2339 12.4962 72.2339 20.6737C72.2339 25.5282 74.5703 29.8374 78.1799 32.5376L76.4645 34.6344C76.4645 34.6344 75.1954 35.9034 76.8874 36.7495C77.8274 37.2195 80.4634 35.9927 82.6219 34.8094C84.0173 35.2451 85.5018 35.4802 87.041 35.4802C95.2185 35.4802 101.848 28.8511 101.848 20.6737C101.848 12.4962 95.2185 5.86719 87.041 5.86719Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.041 5.86719C78.8632 5.86719 72.2339 12.4962 72.2339 20.6737C72.2339 25.5282 74.5703 29.8374 78.1799 32.5376L76.4645 34.6344C76.4645 34.6344 75.1954 35.9034 76.8874 36.7495C77.8274 37.2195 80.4634 35.9927 82.6219 34.8094C84.0173 35.2451 85.5018 35.4802 87.041 35.4802C95.2185 35.4802 101.848 28.8511 101.848 20.6737C101.848 12.4962 95.2185 5.86719 87.041 5.86719Z",
    stroke: "#6D7371",
    strokeWidth: 1.83605,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46747
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2234 26.1518L83.545 24.2619H82.2448V23.6719H84.5175V24.1364L83.2008 26.0211H84.5668V26.6163H82.2234V26.1518Z",
    fill: "#6D7371"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.666394
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8788 24.0496L87.4679 21.1597L85.6193 21.3592L85.5287 20.5201L88.7598 20.1719L88.8311 20.8316L87.2485 23.7133L89.1898 23.5037L89.2816 24.3504L85.9494 24.71L85.8788 24.0496Z",
    fill: "#6D7371"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.844109
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6921 84.0892C12.7405 85.1867 11.8901 86.1156 10.7926 86.164C9.69511 86.2124 8.76626 85.362 8.71787 84.2645C8.66948 83.167 9.51987 82.2381 10.6174 82.1897C11.7149 82.1413 12.6437 82.9917 12.6921 84.0892Z",
    stroke: "#6D7371",
    strokeWidth: 0.918024,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10027 47.5778C7.171 49.1819 5.92814 50.5394 4.32407 50.6101C2.72 50.6809 1.36248 49.438 1.29176 47.8339C1.22103 46.2299 2.46389 44.8724 4.06795 44.8016C5.67202 44.7309 7.02954 45.9738 7.10027 47.5778Z",
    stroke: "#6D7371",
    strokeWidth: 0.918024,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.055 40.6341C102.104 41.7316 101.253 42.6605 100.156 42.7089C99.0581 42.7573 98.1293 41.9069 98.0809 40.8094C98.0325 39.7119 98.8829 38.783 99.9804 38.7346C101.078 38.6863 102.007 39.5366 102.055 40.6341Z",
    stroke: "#6D7371",
    strokeWidth: 0.918024,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.308834
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.18 68.2386C109.645 68.2386 107.59 66.1834 107.59 63.6484C107.59 66.1834 105.535 68.2386 103 68.2386C105.535 68.2386 107.59 70.2937 107.59 72.8287C107.59 70.2937 109.645 68.2386 112.18 68.2386Z",
    stroke: "#6D7371",
    strokeWidth: 0.918024,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.364149
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5043 24.1723C16.9552 24.1723 14.0782 21.2952 14.0782 17.7461C14.0782 21.2952 11.2011 24.1723 7.65198 24.1723C11.2011 24.1723 14.0782 27.0493 14.0782 30.5984C14.0782 27.0493 16.9552 24.1723 20.5043 24.1723Z",
    stroke: "#6D7371",
    strokeWidth: 0.918024,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivityFeed);
export default __webpack_public_path__ + "static/media/NO_ACTIVITY_FEED.c900197b9ed971e09f4b42eb6fd8e0ab.svg";
export { ForwardRef as ReactComponent };